import { css, cx } from '@repo/pandacss/styled-system/css';
import { Badge } from '../../Logo/Badge';
import { HeadingTooltip } from './HeadingTooltip';

type Props = {
  headings: { label?: string; labelTooltip?: string }[];
  shouldApplyStylingUpdates?: boolean;
  className?: string;
};

const baseThStyles = css({
  borderBottomWidth: 'thin',
  borderBottomStyle: 'solid',
  borderTopColor: 'neutral.black',
  borderRightColor: 'neutral.black',
  borderBottomColor: 'neutral.black',
  borderLeftColor: 'neutral.black',
  borderTopWidth: 'none',
  borderRightWidth: 'none',
  borderLeftWidth: 'none',
  paddingRight: '1',
  paddingBottom: '1',
  paddingLeft: '1',
  paddingTop: '0',
  textStyle: { base: 'textSmall', md: 'textBold' },
  fontWeight: { base: 'normal', md: 'medium' },
});

const centeredThStyles = css({
  textAlign: 'center',
});

const leftAlignedThStyles = css({
  textAlign: 'left',
});

const firstThStyles = css({
  textAlign: 'left',
  paddingLeft: '0',
});

export default function SummaryTableHead({
  headings,
  shouldApplyStylingUpdates = false,
  className,
}: Props) {
  const conditionalThStyles = shouldApplyStylingUpdates ? centeredThStyles : leftAlignedThStyles;

  return (
    <tr className={className}>
      {headings.map((heading, index) => {
        const isFirstColumn = index === 0;
        const shouldUseRatingWithIcon =
          heading.label === 'NerdWallet rating' && shouldApplyStylingUpdates;
        return (
          <th
            key={heading.label ?? index}
            className={cx(
              baseThStyles,
              isFirstColumn && !shouldApplyStylingUpdates ? firstThStyles : conditionalThStyles,
            )}
          >
            {shouldUseRatingWithIcon ? (
              <span
                className={css({
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  columnGap: '1',
                  rowGap: '1',
                })}
              >
                <Badge
                  className={css({
                    display: 'flex',
                    flexShrink: '0',
                    width: '5',
                    height: '5',
                    paddingTop: '[3.5px]',
                    paddingRight: '[3.5px]',
                    paddingBottom: '[3.5px]',
                    paddingLeft: '[3.5px]',
                    '& svg': { display: 'block' },
                  })}
                  style={{ lineHeight: 0 }}
                  size={14}
                />
                <span className={css({})} style={{ lineHeight: 1 }}>
                  Rating
                </span>
              </span>
            ) : (
              heading.label
            )}
            {heading.labelTooltip && !shouldUseRatingWithIcon && (
              <HeadingTooltip label={heading.label} tooltip={heading.labelTooltip} />
            )}
          </th>
        );
      })}
      <th
        className={cx(
          baseThStyles,
          conditionalThStyles,
          css({
            display: { base: 'none', md: 'table-cell' },
          }),
        )}
      >
        Learn more
      </th>
    </tr>
  );
}
